
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#464646","fill-rule":"evenodd","d":"M13.288 18h4.44V2h-4.44v16zm-5.643 0h4.44V7.568h-4.44V18zM2 18h4.442v-5.8H2V18z"}})])
          )
        }
      }
    